export const normalizeRegionOptionValues = regions =>
    regions.map(region => ({
        ...region,
        value: String(region.value),
        ...(region.children ? { children: normalizeRegionOptionValues(region.children) } : {}),
    }));
